module.exports = __webpack_public_path__ + "static/media/paresh-gupta.5c5008aa.jpg";